define([], function () {
    return Object;
});
